// extracted by mini-css-extract-plugin
export default {"dialogSize":"DisplayFeatureCards_dialogSize__xTHO4","dialogContent":"DisplayFeatureCards_dialogContent__t1xld","dialogFooter":"DisplayFeatureCards_dialogFooter__njyJT"};